export const de = {
    // Login screen
    modal_login_capital: 'ANMELDEN',
    placeholder_email_address: 'email',
    placeholder_password: 'passwort',
    tooltip_forgot_password: 'Passwort vergessen?',
    log_in: 'Anmelden',

    // Register screen
    modal_signup_capital: 'REGISTRIEREN',
    placeholder_repeat_password: 'Passwort wiederholen',
    agree: 'Ich erkläre mich einverstanden mit den ',
    terms: 'Bedingungen',
    modal_register_capital: 'REGISTRIEREN',
    full_name: 'Vollständiger Name',

    // Price options
    choose_price: 'WÄHLEN SIE IHREN PREIS AUS',
    subscription_price: 'Abonnement',
    asset_price: 'Vermögenswert',
    paywall_subscription_text: 'Sie können Ihr Abonnement jederzeit kündigen.',
    modal_back: 'ZURÜCK',
    next_button: 'WEITER',

    // Payments screen
    pay: 'ZAHLEN',
    pay_with: 'MIT PAYPAL ZAHLEN',
    credit_card: 'kreditkarte',
    payment_pay: 'Zahlen',
    payment_price: 'Preis',
    placeholder_voucher_code: 'gutscheincode',
    placeholder_voucher: 'gutschein hinzufügen',
    card_number: 'kartennummer',
    cardholder_name: 'karteninhaber',

    // Forgot password
    forgot_pass_text:
        'Wir werden Ihnen per E-Mail einen Link zum Zurücksetzen Ihres Passworts schicken.',
    remember_pass: 'Erinnern Sie sich an Ihr Passwort?',
    reset: 'ZURÜCKSETZEN',

    // Set new password
    modal_enter_your_new_password: 'Geben Sie Ihr neues Passwort ein.',
    modal_please_check_your_email:
        'Bitte überprüfen Sie Ihre E-Mail und kopieren Sie den Token, um fortzufahren.',
    placeholder_token: 'token',
    new_password: 'neues Passwort',
    repeat_new_password: 'geben Sie das neue Passwort erneut ein',
    cancel: 'abbrechen',
    set: 'FESTLEGEN',

    // Change password
    update: 'aktualisieren',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Mein Konto',
    member_since: 'Mitglied seid',
    purchases: 'Meine Einkäufe',
    subscriptions: 'Meine Abonnements',
    account_details: 'Kontodaten',
    export_data: 'Meine Daten exportieren',
    delete_account: 'Konto löschen',

    // Purchases/Subscriptions
    purchases_link: 'Einkäufe',
    subscriptions_link: 'Abonnements',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Kaufhistorie',
    purchased: 'Gekauft',
    name: 'name',
    active: 'activ',
    inactive: 'inactive',
    canceled: 'canceled',
    type: 'Type',
    next_transaction: 'Nächste Transaktion',
    cancel_subscription: 'Abonnement stornieren >',
    subscriptions_active: 'Aktive Abonnements',
    expires_at: 'Läuft ab am',
    no_more_subscriptions: 'Es gibt keine weiteren Abonnements.',
    no_available_subscriptions: 'Es sind keine Abonnements verfügbar.',
    no_more_active_accesses: 'Es gibt keine weiteren aktiven Zugänge.',
    no_more_inactive_accesses: 'Es gibt keine weiteren inaktiven Zugänge.',
    no_available_active_accesses: 'Es sind keine aktiven Zugänge verfügbar',
    no_available_inactive_accesses:
        'Es sind keine inaktiven Zugänge verfügbar.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question:
        'Sind Sie sicher, dass Sie Ihre Kontodaten exportieren möchten?',
    export: 'exportieren',
    first_export:
        'Mit dem Kontodatenexport werden alle Ihre persönlichen Daten von Ihrem Konto exportiert. Dies umfasst Folgendes:',
    second_export: 'Ihre persönlichen Informationen',
    third_export: 'Liste mit Ihren Anmeldeprotokollen',
    fourth_export: 'Liste mit Ihren Abonnements',
    fifth_export: 'Liste mit Ihren Zahlungen',
    sixth_export: 'Liste mit Ihren Zugriffen auf Premiuminhalte',
    last_export:
        'Der Export wird Ihnen als Anhang an Ihre E-Mail-Adresse geschickt.',

    // Delete account screen
    delete_question: 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
    delete: 'löschen',
    confirm: 'BESTÄTIGEN',
    first_delete:
        'Mit dem Löschen Ihres Kontos werden alle Ihre persönlichen Daten aus dem System gelöscht. Dies umfasst Folgendes:',
    second_delete:
        'Persönliche Informationen, die Sie während des Registrierungsprozesses bereitgestellt haben',
    third_delete:
        'Standort- und Geräteinformationen, die wir während des Authentifizierungsprozesses erfassen',
    fourth_delete:
        'Alle sonstigen persönlichen Daten, die in anderen Teilen unserer Datenbank gespeichert wurden ',
    fifth_delete:
        'Wir bewahren nur solche personenbezogenen Daten im System auf, die Teil der Transaktions- und Abonnementsdatensätze sind, wenn es von anderen Gesetzen, die wir einzuhalten haben, vorgeschrieben wird..',
    sixth_delete:
        'Neben der Datenlöschung wird Ihr Konto auch stillgelegt. Dementsprechend werden alle Ihre aktiven Abonnements storniert, alle Ihre gegenwärtig aktiven Zugänge zu Vermögenswerte widerrufen und alle Ihre aktiven Benutzersitzungen, einschließlich dieser, beendet. Sie werden nicht mehr in der Lage sein, sich auf dieser Website zu authentifizieren oder Vermögenswerte zu kaufen. Ihre Kontodaten werden unserem Personal in keiner Liste mehr zur Verfügung stehen.',
    seventh_delete:
        'Es kann 1-2 Tage dauern, bis dieser Vorgang abgeschlossen ist. Danach wird Ihnen an Ihre E-Mail-Adresse eine E-Mail geschickt. Nach der erfolgreichen Zustellung wird die E-Mail von unserem System gelöscht..',

    // Inputs validation
    required_field: 'Pflichtfeld',
    email_field: 'bitte geben Sie eine gültige E-Mail ein',
    number_field: 'Wert muss eine Zahl sein',
    matchPass: 'das Passwort stimmt nicht überein',
    minpass_field: 'muss mindestens über 8 Zeichen verfügen',
    minname_field: 'muss mindestens über 2 Zeichen verfügen',

    // Footer
    modal_terms: 'Bedingungen',
    modal_privacy: 'Datenschutz',
    modal_more: 'MEHR',
    modal_faq: 'FAQ',
    modal_protected: 'Was ist das?',
    logout: 'abmelden',
    details: 'meine Angaben',
    preview_protected_by_inplayer: 'Geschützt von',
    modal_support: 'Support',

    dlc_download: 'download',
};



// WEBPACK FOOTER //
// ./src/i18n/german.js